import { useEffect, useState } from 'react';

/** En dessous, le menu reste : en haut de page il n'y a rien à dégager. */
const REVEAL_ZONE_PX = 120;
/** Tremblement de molette ou de trackpad ignoré. */
const SCROLL_JITTER_PX = 8;

/**
 * Menu fixe qui se retire quand on descend et revient dès qu'on remonte :
 * la lecture garde tout l'écran, la navigation reste à un geste.
 */
export function useHiddenOnScroll(enabled) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setHidden(false);
      return undefined;
    }
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (Math.abs(y - lastY) < SCROLL_JITTER_PX) return;
      setHidden(y > lastY && y > REVEAL_ZONE_PX);
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [enabled]);

  return hidden;
}
